import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';
import { Button, Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { GroupingsService, GroupsService } from '../../services';
import GroupingForm from './grouping_form';

@connect(state => {
  return {
    me: state.user.me
  }
})
class GroupingAdd extends React.Component {
  constructor(props) {
    super(props);

    let savedParentGrouping = null;
    let savedSelectedGroup = null;

    // Support for page refresh
    if (localStorage.getItem('savedProps')) {
      let savedProps = JSON.parse(localStorage.getItem('savedProps'));
      savedParentGrouping = savedProps.parentGrouping;
      savedSelectedGroup = savedProps.selectedGroup;
    }

    this.state = {
      parentGrouping: this.props.location.query && this.props.location.query.parentGrouping ? this.props.location.query.parentGrouping : savedParentGrouping,
      availableGroups: null,
      selectedGroup: this.props.location.query && this.props.location.query.selected ? this.props.location.query.selected : savedSelectedGroup,
      groupTimeReq: false,
      saved: false,
      localErrorMessage: null,
      metadata: [],
      showBulkModal: false,
      uploading: false
    }
    this.updateMetadata = this.updateMetadata.bind(this)
  }

  persistPassedProps() {
    let savedProps = {
      parentGrouping: this.state.parentGrouping,
      selectedGroup: this.state.selectedGroup
    }

    localStorage.setItem('savedProps', JSON.stringify(savedProps));
  }

  componentWillUnmount() {
    localStorage.removeItem('savedProps');
  }

  componentDidMount() {
    this.persistPassedProps();

    if (!this.state.parentGrouping) {
      return;
    }

    GroupsService.listAll().then(response => {
      const parentGroup = response.groups.find(group => group.id === this.state.parentGrouping.deviceGroup.id);
      const availableGroups = parentGroup.children.map(group => { return { value: group.id, label: group.name }; });
      let selected = availableGroups[0]
      availableGroups.forEach(group => {
        if (this.state.selectedGroup.name && group.label == this.state.selectedGroup.name) {
          selected = group
        }
      })
      this.setState({ availableGroups: availableGroups, selectedGroup: selected});
    }).catch(error => {
      this.setState({ localErrorMessage: i18next.t('messages.error-loading-groups')});
      console.error(error);
    });
    GroupingsService.getAllMetadataTypes().then((response) => {
      this.setState({types: response.types});
    }).catch((error) => {
      this.setState({ localErrorMessage: i18next.t('messages.could-not-load-group-metadata-types') });
      console.log(error);
    })
  }


  messageDismissCallback() {
    this.setState({
      localErrorMessage: null
    });
  }

  handleSubmit(data) {
    let deviceGroup = data.deviceGroup
    let name = data.name
    let metadata = []
    if(this.state.bounds) {
      data["Bounds"] = this.state.bounds
    }
    if(this.state.latitude) {
      data["Latitude"] = this.state.latitude
    }
    if(this.state.longitude) {
      data["Longitude"] = this.state.longitude
    }
    this.state.types.forEach(function(element) {
      if(data[element.name]) {
        let metadataObject = {stringValue: data[element.name], deviceGroupingMetadataType: element}
        metadata[metadata.length] = metadataObject;
      }
    });

    const grouping = {
      enterprise: { id: this.props.me.enterprise.id },
      parent: { id: this.state.parentGrouping.id },
      deviceGroup: { id: deviceGroup.value },
      name: name,
      metadata: metadata,
      actionsEnabled: data.actionsEnabled === true,
      timezone: data.timezone.value
    };

    GroupingsService.add(grouping).then(response => {
      this.setState({ saved: true });
    }).catch(error => {
      this.setState({ saved: false, localErrorMessage: i18next.t('messages.error-adding-group') });
      console.error(error);
    })
  }

  updateMetadata() {
    let metadata = []
    for (let i = 0; i < this.state.types.length; i++) {
      let element = this.state.types[i]
      if(element.token == "geo_bounds" && this.state.bounds) {
        let metadataObject = {stringValue: this.state.bounds, deviceGroupingMetadataType: element}
        metadata[metadata.length] = metadataObject;
      }
      else if(element.token == "geo_lat" && this.state.latitude) {
        let metadataObject = {stringValue: this.state.latitude, deviceGroupingMetadataType: element}
        metadata[metadata.length] = metadataObject;
      }
      else if(element.token == "geo_lon" && this.state.longitude) {
        let metadataObject = {stringValue: this.state.longitude, deviceGroupingMetadataType: element}
        metadata[metadata.length] = metadataObject;
      }
    }
    this.setState({metadata: metadata})
  }

  updateMapData(bounds, lat, long) {
    if (bounds != null) {
      this.state.bounds = bounds
    }
    if (lat != null && long != null) {
      this.state.latitude = lat
      this.state.longitude = long
    }
    this.updateMetadata()
  }

  uploadCSV(file) {
    this.setState({ uploading: true });
    try {
      GroupingsService.bulkUpload(file, this.state.parentGrouping.id, this.state.selectedGroup.value).then(_ => {
        this.setState({
          successMessage: 'CSV processed.',
          uploading: false,
          saved: true
        });
      }).catch(error => {
        console.error(error);

        if (error.response && error.response && error.response.data  && error.response.data.genericSystemErrorMessage) {
          this.setState({
            localErrorMessage: `Unable to process CSV: ${error.response.data.genericSystemErrorMessage}`,
            uploading: false
          });
        } else {
          this.setState({
            localErrorMessage: `Unable to process CSV.`,
            uploading: false
          });
        }        
      })
    } catch(e) {
      console.error(e);

      this.setState({
        localErrorMessage: `Unable to process CSV.`,
          uploading: false
      });
    }
  }

  render() {
    if (this.state.saved) {
      return (
          <Redirect to={{
            pathname: '/admin/groupings',
            state: {
              from: this.props.location,
              successMessage: i18next.t('pages.groups.groups-saved')
            }
          }}/>
      );
    } else if (this.state.parentGrouping == null) {
      return (
          <Redirect to={{
            pathname: '/admin/groupings',
            state: {
              from: this.props.location,
              errorMessage: i18next.t('pages.groups.add-from-parent')
            }
          }}/>
      );
    } else if (!this.state.availableGroups || !this.state.types || this.state.uploading) {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    } else {
      let tzReq = false;
      if (this.state.parentGrouping.deviceGroup.children.length !== 0) {
        tzReq = this.state.parentGrouping.deviceGroup.children[0].requiresTimezone;
      }
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={`${i18next.t('pages.groups.parent-grouping')}:`}
                         subTitle={this.state.parentGrouping.name}
                         customButton={{
                           title: 'Bulk Import', 
                           method: () => { this.setState({ showBulkModal: true }) }
                         }}
                         backLinkWithParams={{
                           link: {
                             pathname: "/admin/groupings",
                             search: backLinkSearch
                           }
                         }} />
            </div>

            <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />

            <GroupingForm
                onSubmit={this.handleSubmit.bind(this)}
                availableGroups={this.state.availableGroups}
                selectedGroup={this.state.selectedGroup}
                groupTimeReq={tzReq}
                actionsEnabled={false}
                types = {this.state.types}
                metadata = {this.state.metadata}
                groupingBounds={this.state.metadata}
                updateMapData = {this.updateMapData.bind(this)}
                backLinkWithParams={{
                  link: {
                    pathname: "/admin/groupings",
                    search: backLinkSearch
                  }
                }}
            />

            <BulkImportModal 
                show={this.state.showBulkModal} 
                toggleModal={() => this.setState({ showBulkModal: !this.state.showBulkModal })}
                onImport={(files) => { this.uploadCSV(files[0]); }}
            />
          </div>
      );
    }
  }
}

const BulkImportModal = ({show, toggleModal, onImport}) => {
  return (
      <Modal show={show} onHide={toggleModal} dialogClassName="op-floor-plan-modal">
          <Modal.Header closeButton>
            <Modal.Title>{i18next.t('pages.groups.import')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              You may upload a CSV here with a list of locations. The CSV format should be: <br/>
              <pre>
              Location Name, Location Timezone, Location Address
              </pre>
            </div>
            <div className="device-dropzone">
              <Dropzone className="dropzone-format" onDrop={(files) => { toggleModal(); onImport(files); }}>
                <div style={{textAlign: "center", top: "45%", position: "relative"}}> { i18next.t('pages.groups.drag') } </div>
                <button style={{margin: "0 auto", display: "block", position: "relative", top: "110px"}} className="btn btn-sm btn-default"> { i18next.t('pages.groups.upload') } </button>
              </Dropzone>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => {toggleModal();}}>{i18next.t('form-labels.cancel')}</Button>
          </Modal.Footer>
      </Modal>
  );
};

export default GroupingAdd;
